//** Import Modules */
import React, { useEffect, useState } from "react";

import { Button, Checkbox, Form, Space, TimePicker } from "antd";

export default function BusinessHours(props) {
  const {
    checkboxFieldName,
    openTimeFieldName,
    closeTimeFieldName,
    label,
    form,
    previousDayLabel,
    previousDayOpenFieldName,
    previousDayCloseFieldName,
  } = props;

  const [isAvailable, setAvailable] = useState(false);
  const [rangeValue, setRangeValue] = useState([null, null]);

  const onChange = (e) => {
    setAvailable(e.target.checked);

    if (!e.target.checked) {
      setRangeValue([null, null]);
      form.setFieldsValue({
        [openTimeFieldName]: undefined,
        [closeTimeFieldName]: undefined,
      });
    }
  };

  useEffect(() => {
    const checkboxVal = form.getFieldValue(checkboxFieldName);
    const openTime = form.getFieldValue(openTimeFieldName);
    const closeTime = form.getFieldValue(closeTimeFieldName);

    if (checkboxVal === 1 || checkboxVal === "1") {
      setAvailable(true);
      form.setFieldsValue({
        [checkboxFieldName]: true,
      });
    } else if (checkboxVal === true) {
      setAvailable(true);
    } else if (checkboxVal === 0 || checkboxVal === "0") {
      setAvailable(false);
      form.setFieldsValue({
        [checkboxFieldName]: false,
      });
    } else {
      setAvailable(Boolean(checkboxVal));
    }

    if (openTime && closeTime) {
      setRangeValue([openTime, closeTime]);
    }
  }, [checkboxFieldName, closeTimeFieldName, form, openTimeFieldName]);

  const onChangeRange = (newRange) => {
    setRangeValue(newRange || [null, null]);
    form.setFieldsValue({
      [openTimeFieldName]: newRange ? newRange[0] : undefined,
      [closeTimeFieldName]: newRange ? newRange[1] : undefined,
    });
  };

  const canCopyFromPrevious =
    previousDayOpenFieldName && previousDayCloseFieldName && previousDayLabel;

  const copyFromPreviousDay = () => {
    if (!canCopyFromPrevious) {
      return;
    }

    const previousOpen = form.getFieldValue(previousDayOpenFieldName);
    const previousClose = form.getFieldValue(previousDayCloseFieldName);
    const previousIsAvailable = form.getFieldValue(
      previousDayOpenFieldName.replace("open_time", "is_available"),
    );

    if (!previousOpen || !previousClose || !previousIsAvailable) {
      return;
    }

    setAvailable(true);
    setRangeValue([previousOpen, previousClose]);

    form.setFieldsValue({
      [checkboxFieldName]: true,
      [openTimeFieldName]: previousOpen,
      [closeTimeFieldName]: previousClose,
    });
  };

  const hourFormat = "hh:mm A";

  return (
    <div className="business-hours-field business-hours-field--enhanced">
      <Space
        align="baseline"
        wrap
        style={{ width: "100%", justifyContent: "space-between" }}
      >
        <Form.Item
          name={checkboxFieldName}
          valuePropName="checked"
          style={{ marginBottom: 8 }}
        >
          <Checkbox onChange={onChange}>{label}</Checkbox>
        </Form.Item>

        {canCopyFromPrevious && (
          <Button type="link" size="small" onClick={copyFromPreviousDay}>
            Copy {previousDayLabel}
          </Button>
        )}
      </Space>

      {isAvailable && (
        <>
          <Form.Item style={{ marginBottom: 8 }}>
            <TimePicker.RangePicker
              format={hourFormat}
              use12Hours
              minuteStep={15}
              value={rangeValue}
              onChange={onChangeRange}
              allowClear={false}
            />
          </Form.Item>

          <Form.Item
            noStyle
            name={openTimeFieldName}
            rules={[
              {
                required: true,
                message: "Please select opening time",
              },
            ]}
          >
            <span />
          </Form.Item>

          <Form.Item
            noStyle
            name={closeTimeFieldName}
            dependencies={[openTimeFieldName]}
            rules={[
              {
                required: true,
                message: "Please select closing time",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const openTime = getFieldValue(openTimeFieldName);

                  if (!openTime || !value || value.isAfter(openTime)) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error("Closing time must be after opening time"),
                  );
                },
              }),
            ]}
          >
            <span />
          </Form.Item>
        </>
      )}
    </div>
  );
}
